// Thanh lọc tab "Bài đăng" admin Kênh cộng đồng: từ khoá (tiêu đề/nội dung/mã
// giảm giá/mã bài), danh mục, tác giả, khoảng ngày đăng, ghim, trạng thái hiển thị.
// Component "controlled": filters + onChange do hook use-community-post-moderation giữ.
import React, { useEffect, useState } from "react";
import { Input, Select, DatePicker, Button, Tooltip } from "antd";
import communityApi from "../../../api/communityApi";

const { RangePicker } = DatePicker;

export const EMPTY_COMMUNITY_POST_FILTERS = {
    q: "",
    category: undefined,
    owner: undefined,
    range: null, // [dayjs, dayjs] — đổi ra from/to ms ở hook
    pinned: undefined,
    visibility: undefined,
};

export default function CommunityPostFilterBar({ filters, onChange, categories, hideDays }) {
    const [authors, setAuthors] = useState([]);
    const [keyword, setKeyword] = useState(filters.q);

    useEffect(() => {
        communityApi
            .getAdminPostAuthors()
            .then(({ data }) => setAuthors(data.authors || []))
            .catch(() => setAuthors([]));
    }, []);

    // Reset từ ngoài (nút "Xoá lọc") -> đồng bộ lại ô gõ
    useEffect(() => setKeyword(filters.q), [filters.q]);

    const set = (patch) => onChange({ ...filters, ...patch });
    const hasFilter = Object.entries(filters).some(([, v]) => v !== undefined && v !== null && v !== "");

    return (
        <div className="flex flex-wrap gap-2 items-center mb-4">
            <Input.Search
                allowClear
                placeholder="Tìm tiêu đề, nội dung, mã giảm giá, mã bài…"
                style={{ width: 300 }}
                value={keyword}
                onChange={(e) => {
                    setKeyword(e.target.value);
                    // Bấm (x) xoá -> tải lại ngay, không cần Enter
                    if (!e.target.value && filters.q) set({ q: "" });
                }}
                onSearch={(v) => set({ q: v.trim() })}
            />
            <Select
                allowClear
                placeholder="Danh mục"
                style={{ width: 160 }}
                value={filters.category}
                onChange={(v) => set({ category: v })}
                options={(categories || []).map((c) => {
                    const name = typeof c === "string" ? c : c.name;
                    return { label: `#${name}`, value: name };
                })}
            />
            <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="Tác giả"
                style={{ width: 180 }}
                value={filters.owner}
                onChange={(v) => set({ owner: v })}
                options={authors.map((a) => ({ label: a.name || `#${a.userId}`, value: a.userId }))}
            />
            <RangePicker
                value={filters.range}
                onChange={(v) => set({ range: v })}
                format="DD/MM/YYYY"
                style={{ width: 240 }}
                placeholder={["Đăng từ ngày", "Đến ngày"]}
            />
            <Select
                allowClear
                placeholder="Ghim"
                style={{ width: 120 }}
                value={filters.pinned}
                onChange={(v) => set({ pinned: v })}
                options={[
                    { label: "Đang ghim", value: "1" },
                    { label: "Không ghim", value: "0" },
                ]}
            />
            <Tooltip title={hideDays > 0 ? `Bài không ghim của CTV/người dùng đăng quá ${hideDays} ngày bị ẩn khỏi feed (bài admin luôn hiện)` : "Chưa bật tự ẩn bài"}>
                <Select
                    allowClear
                    placeholder="Hiển thị"
                    style={{ width: 150 }}
                    disabled={!hideDays}
                    value={filters.visibility}
                    onChange={(v) => set({ visibility: v })}
                    options={[
                        { label: "Đang hiện", value: "visible" },
                        { label: "Đã tự ẩn", value: "hidden" },
                    ]}
                />
            </Tooltip>
            {hasFilter && <Button onClick={() => onChange(EMPTY_COMMUNITY_POST_FILTERS)}>Xoá lọc</Button>}
        </div>
    );
}
